export class UserQuestionAnswer {
    question_id: number;
    answer_id: number;
    user_id:number;
    quiz_id:number;
    constructor(answer?) {
        if (answer) {
            this.question_id = answer.question_id;
            this.answer_id = answer.answer_id;
            this.user_id = answer.user_id;
            this.quiz_id = answer.quiz_id;
        }
    }
}
